/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MeasureSpecificationVariableEnum } from "./MeasureSpecificationVariableEnum";
import {
  MeasureSpecificationVariableEnumFromJSON,
  MeasureSpecificationVariableEnumFromJSONTyped,
  MeasureSpecificationVariableEnumToJSON,
  MeasureSpecificationVariableEnumToJSONTyped,
} from "./MeasureSpecificationVariableEnum";
import type { MeasureLocation } from "./MeasureLocation";
import {
  MeasureLocationFromJSON,
  MeasureLocationFromJSONTyped,
  MeasureLocationToJSON,
  MeasureLocationToJSONTyped,
} from "./MeasureLocation";
import type { OperatorEnum } from "./OperatorEnum";
import {
  OperatorEnumFromJSON,
  OperatorEnumFromJSONTyped,
  OperatorEnumToJSON,
  OperatorEnumToJSONTyped,
} from "./OperatorEnum";

/**
 *
 * @export
 * @interface MeasureSpecification
 */
export interface MeasureSpecification {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  locations: Array<MeasureLocation>;
  /**
   * measurement variable, one of the following options:
   *  s1 (waterlevel)
   * vol1 (volume)
   * q (discharge)
   * u1 (velocity)
   *
   *
   * * `s1` - waterlevel
   * * `vol1` - volume
   * * `q` - discharge
   * * `u1` - velocity
   */
  variable: MeasureSpecificationVariableEnum;
  /**
   * e.g. >, <, >=, <=
   *
   * * `>` - greater_than
   * * `>=` - greater_than_equal
   * * `<` - less_than
   * * `<=` - less_than_equal
   */
  operator: OperatorEnum;
}

/**
 * Check if a given object implements the MeasureSpecification interface.
 */
export function instanceOfMeasureSpecification(value: object): value is MeasureSpecification {
  if (!("locations" in value) || value["locations"] === undefined) return false;
  if (!("variable" in value) || value["variable"] === undefined) return false;
  if (!("operator" in value) || value["operator"] === undefined) return false;
  return true;
}

export function MeasureSpecificationFromJSON(json: any): MeasureSpecification {
  return MeasureSpecificationFromJSONTyped(json, false);
}

export function MeasureSpecificationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasureSpecification {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    name: json["name"] == null ? undefined : json["name"],
    locations: (json["locations"] as Array<any>).map(MeasureLocationFromJSON),
    variable: MeasureSpecificationVariableEnumFromJSON(json["variable"]),
    operator: OperatorEnumFromJSON(json["operator"]),
  };
}

export function MeasureSpecificationToJSON(json: any): MeasureSpecification {
  return MeasureSpecificationToJSONTyped(json, false);
}

export function MeasureSpecificationToJSONTyped(
  value?: Omit<MeasureSpecification, "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    locations: (value["locations"] as Array<any>).map(MeasureLocationToJSON),
    variable: MeasureSpecificationVariableEnumToJSON(value["variable"]),
    operator: OperatorEnumToJSON(value["operator"]),
  };
}
